'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _aphrodite = require('aphrodite');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _passwordValidator = require('../util/passwordValidator');

var _passwordValidator2 = _interopRequireDefault(_passwordValidator);

var _reactTextInput = require('react-text-input');

var _reactTextInput2 = _interopRequireDefault(_reactTextInput);

var _NationalId = require('./NationalId');

var _NationalId2 = _interopRequireDefault(_NationalId);

var _localizer = require('../util/localizer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * This component is awfully similar to CreateAccountPost, but with some interesting use case differences.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Namely, this component is planned to be used amongst other fields (and won't have it's own submit button), AND these fields
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * don't have to be completed. As a result, it will look to this.props.showValidation to determine if errors should actually be shown (if the user clicks
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * some other submit with invalid details, for example). This component keeps track of what is wrong, the consumer of the component determines if it's a good time to show the errors.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Also, because it's not (always ** read last paragraph **) necessary for the consumer to worry about this component's validation (if a user chooses not to create an account),
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * this component will call this.props.handleCreateAccountCheckbox with a boolean designating the user's intent to do so and that the consumer must now
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * wait for valid password info before proceeding.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Lastly, this component will assess the validation of the content in its fields every time state or props are updated.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * If all of the content is valid at any point it will fire this.props.handleValidInfo() which will allow the consumer to know
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * the chosen password — and implicitly — that this part of the form is completed. (We'll also call resetValidInfo() if this is ever made untrue again.)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * If this component is used with 'mandatory' prop set to 'true', the optional checkbox will be hidden, and the password inputs will be visible always.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Additionally, the this.props.handleCreateAccountCheckbox will not be called, because the consumer should assume that they should wait for
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * this.props.handleValidInfo() to show that the user successfully completed the, now mandatory, password selection.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * */

var styles = _aphrodite.StyleSheet.create({
	mainTitle: {
		marginBottom: '10px'
	},
	mainBlurb: {
		marginBottom: '15px'
	},
	itsFreeLine: {
		margin: '30px 0 15px 0'
	},
	shiftRight: {
		marginLeft: '40px'
	},
	hide: {
		display: 'none'
	},
	createAccountCheckboxWrapper: {
		position: 'absolute',
		width: 'inherit',
		display: 'inline'
	},
	createAccountCheckbox: {
		':before': {
			overflow: 'hidden',
			border: '1px solid #9b9b9b'
		}
	},
	createAccountLine: {
		marginLeft: '40px'
	},
	passwordWarningWrapper: {
		background: '#fff7f7',
		padding: '10px 10px 5px',
		borderRadius: 5,
		border: '1px solid #c72e2e',
		marginTop: 15
	},
	passwordHintWrapper: {
		background: '#eef1f6',
		padding: 5,
		borderRadius: 5,
		marginTop: 5,
		fontSize: 12
	},
	passwordWarningItem: {
		margin: 0,
		paddingBottom: 5
	},
	legalWrapper: {
		marginTop: '20px',
		position: 'relative'
	},
	legalCheckboxWrapper: {
		position: 'absolute',
		width: 'inherit',
		display: 'inline'
	},
	legalCheckbox: {
		':before': {
			overflow: 'hidden',
			border: '1px solid #9b9b9b'
		}
	},
	redBorder: {
		':before': {
			background: '#fff7f7',
			border: '1px solid #c72e2e'
		}
	},
	legalBlurb: {
		lineHeight: '18px',
		marginLeft: '40px'
	},
	legalTextOnly: {
		lineHeight: '18px'
	},
	button: {
		display: 'block',
		margin: '40px auto 0'
	},
	passwordWrapper: {
		marginBottom: '10px'
	},
	dobWrapper: {
		marginBottom: '10px'
	},
	dobHelpText: {
		border: 'solid 1px #0093e0',
		background: '#f2fafe',
		color: 'black',
		borderTop: 'none'
	},
	dropdown: {
		padding: 0,
		textIndent: 12,
		boxSizing: 'content-box',
		appearance: 'none'
	}
});

var CreateAccountPre = function (_React$Component) {
	_inherits(CreateAccountPre, _React$Component);

	function CreateAccountPre(props) {
		_classCallCheck(this, CreateAccountPre);

		var _this = _possibleConstructorReturn(this, (CreateAccountPre.__proto__ || Object.getPrototypeOf(CreateAccountPre)).call(this, props));

		_initialiseProps.call(_this);

		var _props$country = props.country,
		    country = _props$country === undefined ? 'US' : _props$country;

		var countryInfo = (0, _localizer.getCountryInfo)(country);

		_this.state = {
			showCreateAccountFields: false,
			password1: '',
			password2: '',
			dateOfBirth: '', // For cross-border
			occupation: '', // For cross-border
			nationality: '',
			nationalIdNumber: '',
			nationalIdType: '',
			acceptedLegal: false, // For cross-border
			consentCommunication: countryInfo.consentCheckBoxEnabled || false, // For cross-border
			showPasswordHint: false, // For cross-border
			showDateOfBirthHelp: false, // For Date of Birth
			passwordErrors: [],
			optional: false
		};
		return _this;
	}

	// every time the component updates, should check for valid info to fire to parent


	_createClass(CreateAccountPre, [{
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// If someone where calling setState (or anything prompting rerender) within this.props.handleValidInfo or this.props.resetValidInfo
			// it would cause an infinite loop (component would rerender, passwords would still be valid, etc.).
			// This outer `if` statement checks that the password or checkbox has changed before calling the parent method.
			if (prevState.password1 !== this.state.password1 || prevState.password2 !== this.state.password2 || prevState.acceptedLegal !== this.state.acceptedLegal) {
				var passwordErrors = (0, _passwordValidator2.default)(this.state.password1);
				// if the passwords match, have no error, and the user has accepted the legal agreement...
				if (this.doPasswordsMatch() && !passwordErrors.length && this.state.acceptedLegal) {
					// call the prop function that signifies to the parent that everything is ready to go!
					this.props.handleValidInfo(this.state.password1);
				} else {
					// This covers the scenario where a user has valid information, but goes back and changes things to be invalid later
					// consumers need to know to clear the initial valid information from their stores.
					this.props.resetValidInfo();
				}
			}

			// This outer `if` statement checks that the password or acceptedLegal or dateOfBirth or occupation or nationalityor checkbox has changed before calling the parent method.
			if (prevState.password1 !== this.state.password1 || prevState.password2 !== this.state.password2 || prevState.acceptedLegal !== this.state.acceptedLegal || prevState.dateOfBirth !== this.state.dateOfBirth || prevState.occupation !== this.state.occupation || prevState.nationality !== this.state.nationality || prevState.nationalIdType !== this.state.nationalIdType || prevState.nationalIdNumber !== this.state.nationalIdNumber || prevState.consentCommunication !== this.state.consentCommunication) {
				var _ref = {},
				    _ref$passwordValid = _ref.passwordValid,
				    passwordValid = _ref$passwordValid === undefined ? true : _ref$passwordValid,
				    _ref$dobValid = _ref.dobValid,
				    dobValid = _ref$dobValid === undefined ? true : _ref$dobValid,
				    _ref$occValid = _ref.occValid,
				    occValid = _ref$occValid === undefined ? true : _ref$occValid,
				    _ref$legalValid = _ref.legalValid,
				    legalValid = _ref$legalValid === undefined ? true : _ref$legalValid,
				    _ref$natValid = _ref.natValid,
				    natValid = _ref$natValid === undefined ? true : _ref$natValid,
				    _ref$naIdTypeValid = _ref.naIdTypeValid,
				    naIdTypeValid = _ref$naIdTypeValid === undefined ? true : _ref$naIdTypeValid,
				    _ref$naIdNoValid = _ref.naIdNoValid,
				    naIdNoValid = _ref$naIdNoValid === undefined ? true : _ref$naIdNoValid;
				var _props$country2 = this.props.country,
				    country = _props$country2 === undefined ? 'US' : _props$country2;
				var _state = this.state,
				    password1 = _state.password1,
				    acceptedLegal = _state.acceptedLegal,
				    dateOfBirth = _state.dateOfBirth,
				    occupation = _state.occupation,
				    nationality = _state.nationality,
				    nationalIdType = _state.nationalIdType,
				    nationalIdNumber = _state.nationalIdNumber,
				    consentCommunication = _state.consentCommunication;

				var _passwordErrors = (0, _passwordValidator2.default)(password1);
				var countryInfo = (0, _localizer.getCountryInfo)(country);

				var userData = { password: password1 };
				passwordValid = this.doPasswordsMatch() && !_passwordErrors.length;

				if (countryInfo.showLegalCheckBox) {
					userData.legalValid = acceptedLegal;
					legalValid = !!acceptedLegal;
				}

				if (countryInfo.showDOB) {
					userData.dateOfBirth = dateOfBirth;
					userData.dateOfBirthPattern = this.getDobPattern();
					dobValid = (0, _localizer.validateDob)(dateOfBirth, userData.dateOfBirthPattern);
				}

				if (countryInfo.showOccupation) {
					userData.occupation = occupation;
					occValid = !!occupation;
				}

				if (countryInfo.showNationality) {
					userData.nationality = nationality;
					natValid = !!nationality;
				}

				if (countryInfo.showNationalId) {
					userData.nationalIdType = nationalIdType;
					naIdTypeValid = !!nationalIdType;
				}

				if (countryInfo.showNationalId) {
					userData.nationalIdNumber = nationalIdNumber;
					naIdNoValid = !!nationalIdNumber;
				}

				if (countryInfo.showConsentCheckBox) {
					userData.consentCommunication = consentCommunication;
				}

				if (passwordValid && legalValid && dobValid && occValid && natValid && naIdTypeValid && naIdNoValid) {
					// If passwords are identical, have no errors, and legal has
					// been accepted. Call the prop function that signifies to the
					// parent that everything is ready to go!
					if (this.props.handleAllValidInfo) {
						this.props.handleAllValidInfo(userData);
					}
				} else if (this.props.resetAllValidInfo) {
					// This covers the scenario where a user has valid information,
					// but goes back and changes things to be invalid later
					// consumers need to know to clear the initial valid information
					// from their stores.
					this.props.resetAllValidInfo(userData);
				}
			}
		}
	}, {
		key: 'UNSAFE_componentWillReceiveProps',
		value: function UNSAFE_componentWillReceiveProps(nextProps) {
			// in the case that the user fills nothing out after ticking the create account box
			// we need to show password validation errors for empty password fields
			this.setState({
				passwordErrors: (0, _passwordValidator2.default)(this.state.password1)
			});

			// Set optional to false when its not mandatory
			// This is required for re-setting "optional" when it changes
			// to mandatory from optional
			if (this.props.mandatory) {
				this.setState({
					optional: false
				});
			}
		}

		/**
  * check that the two passwords within state are matching
  * @return {boolean}
  */


		/**
  * Return dobPattern from specified props or get it from countryInfo
  */


		/**
  * check if date of birth is valid
  * @return {string}
  */

	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _state2 = this.state,
			    acceptedLegal = _state2.acceptedLegal,
			    passwordErrors = _state2.passwordErrors,
			    dateOfBirth = _state2.dateOfBirth,
			    occupation = _state2.occupation,
			    nationality = _state2.nationality,
			    nationalIdType = _state2.nationalIdType,
			    nationalIdNumber = _state2.nationalIdNumber,
			    dobReqErrors = _state2.dobReqErrors,
			    dobErrors = _state2.dobErrors,
			    dobIs18Errors = _state2.dobIs18Errors,
			    occupationError = _state2.occupationError,
			    nationalityError = _state2.nationalityError,
			    showPasswordHint = _state2.showPasswordHint,
			    showDateOfBirthHelp = _state2.showDateOfBirthHelp;
			var _props = this.props,
			    showValidationErrors = _props.showValidationErrors,
			    _props$country3 = _props.country,
			    country = _props$country3 === undefined ? 'US' : _props$country3,
			    supportedCountries = _props.supportedCountries,
			    _props$defaultIdType = _props.defaultIdType,
			    defaultIdType = _props$defaultIdType === undefined ? '' : _props$defaultIdType;

			var countryInfo = (0, _localizer.getCountryInfo)(country);
			var dateOfBirthHelp = showDateOfBirthHelp && countryInfo.showDOBHelp;
			var legalCheckBoxErrorsExist = countryInfo.showLegalCheckBox && !acceptedLegal;
			var passwordErrorsExist = !this.doPasswordsMatch() || !!passwordErrors.length;
			var occupationErrorsExist = showValidationErrors && countryInfo.showOccupation && (occupationError || !occupation);
			var nationalityErrorsExist = showValidationErrors && countryInfo.showNationality && (nationalityError || !nationality);
			var dateOfBirthErrorsExist = showValidationErrors && countryInfo.showDOB && !dateOfBirthHelp && (dobErrors || dobReqErrors || !dateOfBirth);
			var dateOfBirthIs18ErrorsExist = showValidationErrors && countryInfo.showDOBMust18 && dobIs18Errors && !dateOfBirthHelp;
			var nationalIdTypeErrorsExist = showValidationErrors && countryInfo.showNationalId && !nationalIdType;
			var nationalIdNoErrorsExist = showValidationErrors && countryInfo.showNationalId && !nationalIdNumber;
			var shouldShowErrorMessages = showValidationErrors && (passwordErrorsExist || legalCheckBoxErrorsExist || occupationErrorsExist || nationalityErrorsExist || dateOfBirthErrorsExist || dateOfBirthIs18ErrorsExist);
			var occupations = this.props.occupations || countryInfo.occupations;

			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h2',
					{ className: (0, _aphrodite.css)(styles.mainTitle) },
					this.props.mainTitle
				),
				_react2.default.createElement(
					'p',
					{ className: (0, _aphrodite.css)(styles.mainBlurb) },
					this.props.mainBlurb
				),
				!this.props.mandatory && // if the password is optional — show the optional checkbox
				_react2.default.createElement(
					'span',
					null,
					_react2.default.createElement(
						'p',
						{ className: (0, _aphrodite.css)(styles.itsFreeLine) + ' vx_text-5' },
						this.props.itsFreeLine
					),
					_react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)('vx_checkbox', (0, _aphrodite.css)(styles.createAccountCheckboxWrapper)) },
						_react2.default.createElement('input', {
							value: this.state.optional,
							onChange: this.handleCreateAccountCheckbox,
							type: 'checkbox', id: 'createAccountCheckbox' }),
						_react2.default.createElement('label', { htmlFor: 'createAccountCheckbox', className: (0, _aphrodite.css)(styles.createAccountCheckbox) })
					),
					_react2.default.createElement(
						'p',
						{ className: (0, _aphrodite.css)(styles.createAccountLine) },
						this.props.createAccountCheckboxContent
					)
				),
				_react2.default.createElement(
					'div',
					{ className: (0, _aphrodite.css)(!this.props.mandatory && styles.shiftRight, !this.props.mandatory && !this.state.optional && styles.hide) },
					!this.props.mandatory && _react2.default.createElement(
						'div',
						null,
						this.props.createAccountHelp1 && _react2.default.createElement(
							'p',
							{ className: 'vx_text-5' },
							this.props.createAccountHelp1
						),
						this.props.createAccountHelp2 && _react2.default.createElement(
							'p',
							{ className: 'vx_text-5' },
							this.props.createAccountHelp2
						)
					),
					_react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)((0, _aphrodite.css)(styles.passwordWrapper), { 'vx_has-error': showValidationErrors && passwordErrorsExist }) },
						_react2.default.createElement(_reactTextInput2.default, {
							className: 'vx_form-control vx_form-control_complex',
							label: this.props.label1,
							name: 'password1',
							type: 'password',
							id: 'password1',
							handleMouseOut: function handleMouseOut() {
								return _this2.hidePasswordHint(countryInfo.showPasswordHint);
							},
							handleBlur: function handleBlur() {
								return _this2.hidePasswordHint(countryInfo.showPasswordHint);
							},
							handleChange: function handleChange(password) {
								return _this2.handleUpdatePasswords(password, 'password1', countryInfo.showPasswordHint);
							}
						}),
						showPasswordHint && countryInfo.showPasswordHint && _react2.default.createElement(
							'div',
							{ id: 'password_hint', className: (0, _aphrodite.css)(styles.passwordHintWrapper) },
							this.props.passwordWarnings._HINT1 && _react2.default.createElement(
								'div',
								null,
								this.props.passwordWarnings._HINT1
							),
							this.props.passwordWarnings._HINT2 && _react2.default.createElement(
								'div',
								null,
								this.props.passwordWarnings._HINT2
							),
							this.props.passwordWarnings._HINT3 && _react2.default.createElement(
								'div',
								null,
								this.props.passwordWarnings._HINT3
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)((0, _aphrodite.css)(styles.passwordWrapper), { 'vx_has-error': showValidationErrors && passwordErrorsExist }) },
						_react2.default.createElement(_reactTextInput2.default, {
							className: 'vx_form-control vx_form-control_complex',
							label: this.props.label2,
							name: 'password2',
							type: 'password',
							id: 'password2',
							handleChange: function handleChange(password) {
								return _this2.handleUpdatePasswords(password, 'password2');
							}
						})
					),
					countryInfo.showDOB && _react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)((0, _aphrodite.css)(styles.dobWrapper), { 'vx_has-message': dateOfBirthHelp }, { 'vx_has-error': showValidationErrors && dateOfBirthErrorsExist }) },
						_react2.default.createElement(_reactTextInput2.default, { type: 'tel',
							id: 'dateofbirth',
							name: 'dateofbirth',
							className: 'vx_form-control vx_form-control_complex',
							label: this.props.labeldob,
							autocomplete: 'off',
							helpText: this.props.dobHelp,
							handleChange: function handleChange(date) {
								return _this2.handleChangeDob(date);
							},
							handleFocus: function handleFocus(date) {
								return _this2.handleDobFocus(date);
							},
							handleBlur: function handleBlur(date) {
								return _this2.handleDobBlur(date);
							} }),
						dateOfBirthHelp && _react2.default.createElement(
							'span',
							{ className: (0, _classnames2.default)((0, _aphrodite.css)(styles.dobHelpText), 'vx_form-control-message') },
							this.props.passwordWarnings._HELP_DOB
						)
					),
					countryInfo.showOccupation && _react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)({ 'vx_has-error': showValidationErrors && occupationErrorsExist }),
							style: { paddingTop: 0, margin: '10px 0 0', position: 'relative' } },
						_react2.default.createElement(
							'select',
							{ name: 'occupation', id: 'occupation',
								className: 'vx_form-control ' + (0, _aphrodite.css)(styles.dropdown),
								value: this.state.occupation,
								onChange: function onChange(value) {
									return _this2.handleChangeOccupation(value);
								},
								style: styles.dropdown },
							_react2.default.createElement(
								'option',
								{ value: '', disabled: true },
								this.props.labelocc
							),
							occupations.map(function (item) {
								return _react2.default.createElement(
									'option',
									{ key: item.label, value: item.value },
									item.label
								);
							})
						),
						_react2.default.createElement('label', { htmlFor: this.props.labelocc, className: 'icon icon-arrow-down-small', style: {
								position: 'absolute', right: 10, top: '50%', cursor: 'default', pointerEvents: 'none' } })
					),
					countryInfo.showNationality && _react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)({ 'vx_has-error': showValidationErrors && nationalityErrorsExist }),
							style: { paddingTop: 0, margin: '10px 0 0', position: 'relative' } },
						_react2.default.createElement(
							'select',
							{ name: 'nationality', id: 'nationality',
								className: 'vx_form-control ' + (0, _aphrodite.css)(styles.dropdown),
								value: this.state.nationality,
								onChange: function onChange(value) {
									return _this2.handleChangeNationality(value);
								},
								style: styles.dropdown },
							_react2.default.createElement(
								'option',
								{ value: '', disabled: true },
								this.props.labelnationality
							),
							supportedCountries.map(function (item) {
								return _react2.default.createElement(
									'option',
									{ key: item.countryCode, value: item.countryCode },
									item.countryName
								);
							})
						),
						_react2.default.createElement('label', { htmlFor: this.props.labelocc, className: 'icon icon-arrow-down-small', style: {
								position: 'absolute', right: 10, top: '50%', cursor: 'default', pointerEvents: 'none' } })
					),
					countryInfo.showNationalId && _react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)((0, _aphrodite.css)(styles.passwordWrapper), { 'vx_has-error': showValidationErrors && passwordErrorsExist }) },
						_react2.default.createElement(_NationalId2.default, _extends({
							validNationalIdType: this.handleNationalIdType,
							validNationalIdNumber: this.handleNationalIdNumber,
							resetNationalId: this.resetNationalId,
							defaultIdType: defaultIdType
						}, this.props))
					),
					shouldShowErrorMessages && _react2.default.createElement(
						'div',
						{ className: (0, _aphrodite.css)(styles.passwordWarningWrapper) },
						showValidationErrors && passwordErrorsExist && this.renderPasswordErrors(),
						showValidationErrors && countryInfo.showDOB && dobErrors && !dateOfBirthHelp && _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'p',
								{ className: (0, _classnames2.default)('test_legalMessage', (0, _aphrodite.css)(styles.passwordWarningItem)) },
								this.props.passwordWarnings._INVALID_DOB
							)
						),
						showValidationErrors && countryInfo.showDOB && (dobReqErrors || !dateOfBirth) && !dateOfBirthHelp && _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'p',
								{ className: (0, _classnames2.default)('test_legalMessage', (0, _aphrodite.css)(styles.passwordWarningItem)) },
								this.props.passwordWarnings._REQUIRED_DOB
							)
						),
						dateOfBirthIs18ErrorsExist && _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'p',
								{ className: (0, _classnames2.default)('test_legalMessage', (0, _aphrodite.css)(styles.passwordWarningItem)) },
								this.props.passwordWarnings._MUST_18_DOB
							)
						),
						occupationErrorsExist && _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'p',
								{ className: (0, _classnames2.default)('test_occupationMessage', (0, _aphrodite.css)(styles.passwordWarningItem)) },
								this.props.passwordWarnings._OCCUPATION
							)
						),
						nationalityErrorsExist && _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'p',
								{ className: (0, _classnames2.default)('test_occupationMessage', (0, _aphrodite.css)(styles.passwordWarningItem)) },
								this.props.passwordWarnings._NATIONALITY
							)
						),
						nationalIdTypeErrorsExist && _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'p',
								{ className: (0, _classnames2.default)('test_occupationMessage', (0, _aphrodite.css)(styles.passwordWarningItem)) },
								this.props.passwordWarnings._NATIONAL_ID_TYPE
							)
						),
						nationalIdNoErrorsExist && _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'p',
								{ className: (0, _classnames2.default)('test_occupationMessage', (0, _aphrodite.css)(styles.passwordWarningItem)) },
								this.props.passwordWarnings._NATIONAL_ID_NUMBER
							)
						),
						showValidationErrors && countryInfo.showLegalCheckBox && !acceptedLegal && _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'p',
								{ className: (0, _classnames2.default)('test_legalMessage', (0, _aphrodite.css)(styles.passwordWarningItem)) },
								this.props.passwordWarnings._LEGAL_CHECKBOX
							)
						)
					),
					countryInfo.showLegalCheckBox && _react2.default.createElement(
						'div',
						{ className: (0, _aphrodite.css)(styles.legalWrapper) },
						_react2.default.createElement(
							'div',
							{ className: (0, _classnames2.default)('vx_checkbox', (0, _aphrodite.css)(styles.legalCheckboxWrapper)) },
							_react2.default.createElement('input', {
								onChange: this.handleLegalCheckbox,
								type: 'checkbox', id: 'accountLegalCheckbox' }),
							_react2.default.createElement('label', { htmlFor: 'accountLegalCheckbox', className: (0, _aphrodite.css)(styles.legalCheckbox, showValidationErrors && !acceptedLegal && styles.redBorder) })
						),
						_react2.default.createElement('p', { className: (0, _aphrodite.css)(styles.legalBlurb) + ' vx_text-legal', dangerouslySetInnerHTML: { __html: this.props.legalBlurbHTML } })
					),
					countryInfo.showConsentCheckBox && _react2.default.createElement(
						'div',
						{ className: (0, _aphrodite.css)(styles.legalWrapper) },
						_react2.default.createElement(
							'div',
							{ className: (0, _classnames2.default)('vx_checkbox', (0, _aphrodite.css)(styles.legalCheckboxWrapper)) },
							_react2.default.createElement('input', {
								checked: this.state.consentCommunication,
								onChange: this.handleConsentCheckbox,
								type: 'checkbox', id: 'consentCheckbox' }),
							_react2.default.createElement('label', { htmlFor: 'consentCheckbox' })
						),
						_react2.default.createElement('p', { className: (0, _aphrodite.css)(styles.legalBlurb) + ' vx_text-legal', dangerouslySetInnerHTML: { __html: this.props.consentBlurbHTML } })
					),
					countryInfo.showLegalTextOnly && _react2.default.createElement(
						'div',
						{ className: (0, _aphrodite.css)(styles.legalWrapper) },
						_react2.default.createElement('p', { id: 'legalTextOnly', className: (0, _aphrodite.css)(styles.legalTextOnly) + ' vx_text-legal', dangerouslySetInnerHTML: { __html: this.props.legalOnlyHTML } })
					)
				)
			);
		}
	}]);

	return CreateAccountPre;
}(_react2.default.Component);

CreateAccountPre.propTypes = {
	mainTitle: _propTypes2.default.string.isRequired,
	mainBlurb: _propTypes2.default.string.isRequired,
	legalBlurbHTML: _propTypes2.default.string.isRequired,
	createAccountCheckboxContent: _propTypes2.default.string.isRequired,
	handleValidInfo: _propTypes2.default.func.isRequired,
	resetValidInfo: _propTypes2.default.func.isRequired,

	handleAllValidInfo: _propTypes2.default.func,
	resetAllValidInfo: _propTypes2.default.func,

	legalOnlyHTML: _propTypes2.default.string,
	labelnationality: _propTypes2.default.string,
	consentBlurbHTML: _propTypes2.default.string,
	supportedCountries: _propTypes2.default.array,
	occupations: _propTypes2.default.array,

	showValidationErrors: _propTypes2.default.bool.isRequired,
	itsFreeLine: _propTypes2.default.string,
	createAccountHelp1: _propTypes2.default.string,
	createAccountHelp2: _propTypes2.default.string,
	labeldob: _propTypes2.default.string,
	helpdob: _propTypes2.default.string,
	dobPattern: _propTypes2.default.string,
	dobHelp: _propTypes2.default.string,
	occupationError: _propTypes2.default.bool,
	nationalityError: _propTypes2.default.bool,
	defaultIdType: _propTypes2.default.string,

	label1: _propTypes2.default.string,
	label2: _propTypes2.default.string,
	handleCreateAccountCheckbox: _propTypes2.default.func,
	showCreateAccountFields: _propTypes2.default.bool,
	mandatory: _propTypes2.default.bool,
	country: _propTypes2.default.string,
	labelocc: _propTypes2.default.string,
	passwordWarnings: _propTypes2.default.shape({
		_MISMATCH: _propTypes2.default.string.isRequired,
		_IS_NULL: _propTypes2.default.string.isRequired,
		_TOO_SHORT: _propTypes2.default.string.isRequired,
		_TOO_LONG: _propTypes2.default.string.isRequired,
		_CONTAINS_REPEATED_CHARACTERS: _propTypes2.default.string.isRequired,
		_CONTAINS_NUMBER_SEQUENCE: _propTypes2.default.string.isRequired,
		_CONTAINS_LETTER_SEQUENCE: _propTypes2.default.string.isRequired,
		_CONTAINS_NUMBER_LETTER_SEQUENCE: _propTypes2.default.string.isRequired,
		_IS_BLACKLISTED: _propTypes2.default.string.isRequired,
		_CONTAINS_SPACES: _propTypes2.default.string.isRequired,
		_HAS_ILLEGAL_CHARACTERS: _propTypes2.default.string.isRequired,
		_LEGAL_CHECKBOX: _propTypes2.default.string.isRequired,
		_INVALID_DOB: _propTypes2.default.string,
		_REQUIRED_DOB: _propTypes2.default.string,
		_HELP_DOB: _propTypes2.default.string,
		_MUST_18_DOB: _propTypes2.default.string,
		_OCCUPATION: _propTypes2.default.string,
		_NATIONALITY: _propTypes2.default.string,
		_NATIONAL_ID_TYPE: _propTypes2.default.string,
		_NATIONAL_ID_NUMBER: _propTypes2.default.string,
		_HINT1: _propTypes2.default.string,
		_HINT2: _propTypes2.default.string,
		_HINT3: _propTypes2.default.string
	}).isRequired
};

var _initialiseProps = function _initialiseProps() {
	var _this3 = this;

	this.handleCreateAccountCheckbox = function (event) {
		_this3.props.handleCreateAccountCheckbox(event.target.checked);
		_this3.setState({
			optional: event.target.checked,
			showCreateAccountFields: event.target.checked
		});
	};

	this.handleUpdatePasswords = function (password, whichInput, hasPasswordHint) {
		var _newState;

		var newState = (_newState = {}, _defineProperty(_newState, whichInput, password), _defineProperty(_newState, 'showPasswordHint', hasPasswordHint), _defineProperty(_newState, 'passwordErrors', whichInput === 'password1' ? (0, _passwordValidator2.default)(password) : _this3.state.passwordErrors), _newState);
		_this3.setState(newState);
		return password; // returning for TextInput https://github.paypal.com/react/react-text-input
	};

	this.hidePasswordHint = function (isHint) {
		if (isHint) {
			_this3.setState({ showPasswordHint: false });
		}
	};

	this.handleLegalCheckbox = function (event) {
		_this3.setState({
			acceptedLegal: event.target.checked
		});
	};

	this.handleConsentCheckbox = function (event) {
		_this3.setState({
			consentCommunication: event.target.checked
		});
	};

	this.doPasswordsMatch = function () {
		return _this3.state.password1 === _this3.state.password2;
	};

	this.getDobPattern = function () {
		if (_this3.props.dobPattern) {
			return _this3.props.dobPattern;
		}

		var _props$country4 = _this3.props.country,
		    country = _props$country4 === undefined ? 'US' : _props$country4;

		var countryInfo = (0, _localizer.getCountryInfo)(country);

		return countryInfo.DOBPattern;
	};

	this.handleChangeDob = function (date) {
		var dateOfBirth = (0, _localizer.getFormattedDob)(date, _this3.getDobPattern());

		_this3.setState({
			dateOfBirth: dateOfBirth,
			dobReqErrors: date === '',
			dobErrors: date !== '' && !(0, _localizer.validateDob)(dateOfBirth, _this3.getDobPattern())
		});
		return dateOfBirth;
	};

	this.validateDobIs18 = function (date) {
		_this3.setState({
			dobIs18Errors: !(0, _localizer.validateDobIs18)(date, _this3.getDobPattern())
		});
	};

	this.handleDobBlur = function (date) {
		_this3.setState({ dobReqErrors: date === '', showDateOfBirthHelp: false });
		_this3.validateDobIs18(date);
	};

	this.handleDobFocus = function (date) {
		_this3.setState({ dobReqErrors: false, showDateOfBirthHelp: true });
	};

	this.handleChangeOccupation = function (event) {
		var occupation = event.target.value;
		_this3.setState({ occupationError: occupation === '', occupation: occupation });
		return occupation;
	};

	this.handleChangeNationality = function (event) {
		var nationality = event.target.value;
		_this3.setState({ nationalityError: nationality === '', nationality: nationality });
		return nationality;
	};

	this.renderPasswordErrors = function () {
		return _react2.default.createElement(
			'span',
			null,
			!_this3.doPasswordsMatch() && _react2.default.createElement(
				'p',
				{ className: (0, _classnames2.default)('test_passwordMessage', (0, _aphrodite.css)(styles.passwordWarningItem)) },
				_this3.props.passwordWarnings._MISMATCH
			),
			_this3.state.passwordErrors.map(function (code) {
				var warningMessage = _this3.props.passwordWarnings[code];
				return _react2.default.createElement(
					'p',
					{ key: code, className: (0, _classnames2.default)('test_passwordMessage', (0, _aphrodite.css)(styles.passwordWarningItem)) },
					warningMessage
				);
			})
		);
	};

	this.handleNationalIdType = function (nationalIdType) {
		_this3.setState({ nationalIdType: nationalIdType });
	};

	this.handleNationalIdNumber = function (nationalIdNumber) {
		_this3.setState({ nationalIdNumber: nationalIdNumber });
	};

	this.resetNationalId = function () {
		_this3.setState({ nationalIdType: null, nationalIdNumber: null });
	};
};

exports.default = CreateAccountPre;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/components/CreateAccountPre.js
// module id = 699
// module chunks = 5